const appointmentType: { [key: string]: string } = {
  CHECKUP: "Checkup",
  EMERGENCY: "Emergência",
  FOLLOWUP: "Retorno",
  ROUTINE: "Rotina",
  WALKIN: "Encaixe",
  FIRSTAPPOINTMENT: "Primeiro atendimento",
  prontoatendimento: "Pronto Atendimento",
  EVOLUTION: "Evolução",
};

const appointmentStatus: { [key: string]: string } = {
  booked: "Agendado",
  pending: "Pagamento pendente",

  fulfilled: "Realizado",
  cancelled: "Cancelado",
};

const signedDocsType: { [key: string]: string } = {
  Receituário: "Receita médica",
  Solicitação: "Solicitação de exame",
  Procedimento: "Procidimento",
  "Atestado Médico": "Relatório",
};

const protocolStatus: { [key: string]: string } = {
  "in-progress": "Desenvolvimento",
  amended: "Alterado",
  stopped: "Suspenso",
  completed: "Completo",
};

const category: { [key: string]: string } = {
  food: "Alimento",
  medication: "Medicamento",
  environment: "Ambiente",
  biologic: "Biológico",
  laboratoryprocedure: "Laboratorial",
  imaging: "Imagem",
  counselling: "Aconselhamento",
  education: "Educação",
  surgicalprocedure: "Procedimento cirúrgico",
};

const verificationStatus: { [key: string]: string } = {
  unconfirmed: "Não confirmado",
  confirmed: "Confirmado",
  presumed: "Presumido",
  refuted: "Refutado",
  provisional: "Provisório",
  "entered-in-error": "Registrado por engano",
};

const clinicalStatus: { [key: string]: string } = {
  active: "Ativo",
  inactive: "Inativo",
  resolved: "Resolvido",
  recurrence: "Recorrente",
  remission: "Remissão",
  unknown: "Desconhecido",
};

const criticality: { [key: string]: string } = {
  low: "Baixo",
  high: "Alto",
  "unable-to-assess": "Incapaz de avaliar",
  recurrence: "Recorrente",
  remission: "Remissão",
  unknown: "Desconhecido",
};

const roles: { [key: string]: string } = {
  practitioner: "Profissional de saúde",
  manager: "Secretariado",
  owner: "Proprietário",
  invited: "Convidado",
  associated: "Sócio (associação)",
};

const actor: { [key: string]: string } = {
  Practitioner: "Profissional",
  HealthcareService: "Serviço de saúde",
  Patient: "Paciente",
  Location: "Clínica",
};

const serviceRequestStatus: { [key: string]: string } = {
  draft: "Rascunho",
  active: "Ativo",
  completed: "Concluído",
  revoked: "Revogado",
  onhold: "Em espera",
  "on-hold": "Em espera",
  enteredinerror: "Erro",
  "entered-in-error": "Erro",
  unknown: "Desconhecido",
};

const serviceRequestPriority: { [key: string]: string } = {
  routine: "Rotina",
  urgent: "Urgente",
  asap: "Imediato",
  stat: "Emergência",
  unknown: "Desconhecida",
};

const medicationRequestStatus: { [key: string]: string } = {
  active: "Ativo",
  valid: "Ativo",
  "on-hold": "Em espera",
  cancelled: "Cancelado",
  completed: "Concluído",
  "entered-in-error": "Registrado por engano",
  draft: "Não informado",
  stopped: "Interrompido",
  unknown: "Desconhecido",
};

/** Rótulo em português do status FHIR de MedicationRequest. */
export function getMedicationRequestStatusLabel(status?: string | null): string {
  if (!status) return "—";
  return medicationRequestStatus[status] ?? status;
}

export const useDict = {
  appointmentType,
  appointmentStatus,
  roles,
  actor,
  criticality,
  category,
  verificationStatus,
  signedDocsType,
  clinicalStatus,
  protocolStatus,
  serviceRequestStatus,
  serviceRequestPriority,
  medicationRequestStatus,
};
